import React from "react";
import PropTypes from "prop-types";
import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";

import { StyledProgressBar } from "./styled";
import { ICONS, Icon } from "../Icons";

const statusIcons = {
  inActive: ICONS.inActive,
  active: ICONS.active,
  completed: ICONS.completed
};

export const ProgressBar = ({
  label = "Your info",
  value = 0,
  status = "inActive",
  isMobile = false
}) => {
  let extraClass;
  switch (status) {
    case "completed":
      extraClass = "completed";
      break;
    case "inActive":
      extraClass = "inActive";
      break;
    default:
      extraClass = "active";
  }

  const isMobileClass = isMobile ? "mobileProgressBar" : "";

  return (
    <StyledProgressBar isMobile={isMobile}>
      <Box className={`progressBarStep ${extraClass} ${isMobileClass}`}>
        {!isMobile && (
          <div className="progressBarStepHeader" data-testid="progressBarStepHeader">
            <Icon
              className={`progressBarIcon ${status}`}
              name={statusIcons[status]}
              alt="selected icon"
            />
            <span className="progressBarLabel">{label}</span>
          </div>
        )}
        <div className="progressBarSubsteps">
          <LinearProgress variant="determinate" value={value} />
        </div>
      </Box>
    </StyledProgressBar>
  );
};

ProgressBar.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  status: PropTypes.oneOf(["inActive", "active", "completed"]),
  isMobile: PropTypes.bool
};
